import script from "./TatamiView.vue?vue&type=script&setup=true&lang=js"
export * from "./TatamiView.vue?vue&type=script&setup=true&lang=js"

import "./TatamiView.vue?vue&type=style&index=0&id=19aebda4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19aebda4"]])

export default __exports__